<template>
  <div
    v-if="notEnoughProduction"
    class="tw-bg-amber-50 tw-border tw-border-amber-200 tw-rounded-xl tw-p-4 tw-flex tw-gap-3"
  >
    <svg class="tw-w-5 tw-h-5 tw-text-amber-500 tw-flex-shrink-0 tw-mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
    </svg>
    <div class="tw-text-sm">
      <div class="tw-font-semibold tw-text-amber-800">Niet gesynchroniseerd met Energize</div>
      <div class="tw-text-amber-700 tw-mt-1">
        Deze woning heeft te weinig productie (minder dan 100 Wh sinds activatie). Er is daarom geen
        Energize-account aangemaakt, dus de huurder ziet de opbrengst nog niet in de app.
      </div>
      <div class="tw-text-xs tw-text-amber-600 tw-mt-1.5">
        Zodra de productie boven de drempel komt, wordt het account bij een volgende sync automatisch
        aangemaakt. Status komt uit de laatste sync-run, dus kan een ronde achterlopen.
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  meterDetail: { type: Object, default: null },
})

// Gezet door de Dagster asset insert_update_latest_clients_to_auth_table wanneer de
// cumulatieve opbrengst sinds activatie onder de 100 Wh ligt: er wordt dan geen
// auth user/profile in Energize aangemaakt en de meter komt niet in de app.
const notEnoughProduction = computed(
  () => props.meterDetail?.client_creation_msg === 'NOT ENOUGH PRODUCTION'
)
</script>
